import React, { useState, useEffect } from "react";
import {
  Text,
  ActionIcon,
  Container,
  Group,
  List,
  Alert,
  Title,
  Center,
  Loader,
  Image,
  Box,
} from "@mantine/core";
import { useStore } from "../store";
import { Link } from "wouter";
import { IconDots, IconTrash } from "@tabler/icons-react";
import DatasetCard from "./DatasetCard.jsx";
import { getTrainingDatasets } from "../api.js";

export default function TrainingDataSetsList() {
  const profile = useStore((state) => state.profile);
  const activated =
    profile?.plan === "Pro" ||
    profile?.plan === "Premium" ||
    profile?.plan === "Basic";
  const [datasets, setDatasets] = useState(null);

  useEffect(() => {
    getTrainingDatasets().then((data) => {
      setDatasets(data);
    });
  }, []);

  return (
    <Container>
      <Group mt="sm" mb="lg" justify="space-between">
        <Title>Custom AI Models</Title>
      </Group>

      {!activated && (
        <>
          <Alert title="Subscription required" color="red" mb="md">
            This feature allows you to train an AI model based on a number of
            images / selfies to create virtual photo shootings.
            <br />
            However, because of the compute cost involved, you need a
            subscription to use this feature. Please visit the{" "}
            <Link to="/payment/plans">plans page</Link> to upgrade your
            subscription.
          </Alert>

          <Box mt="lg" p={60}>
            Screenshot
            <Image
              src="gallery-select.jpg"
              alt="Select images in the gallery"
            />
          </Box>
        </>
      )}

      {activated && (
        <>
          {!datasets && (
            <Center>
              <Loader size="xl" mt="xl" />
            </Center>
          )}

          {datasets?.length === 0 && (
            <>
              <Alert title="No datasets yet">
                No datasets exist yet. Upload a bunch of images of yourself and
                select a them in the gallery, then choose "Create Model" from
                the context menu (
                <ActionIcon size="xs" variant="default">
                  <IconDots size="12" />{" "}
                </ActionIcon>
                in the bottom right) to get started!
              </Alert>
              <Box mt="lg" p={60}>
                Screenshot
                <Image
                  src="gallery-select.jpg"
                  alt="Select images in the gallery"
                />
              </Box>
            </>
          )}

          <List>
            {datasets?.map((ds) => (
              <DatasetCard key={ds.id} dataset={ds} />
            ))}
          </List>
        </>
      )}
    </Container>
  );
}
